import React from 'react';
import VideosView from './VideosView';

export const VideosContainer = () => {
  return (
    <div>
      <VideosView />
    </div>
  );
};
